import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { UPDATE } from "react-admin";
import {
  isEmpty,
  prop,
  uniqBy,
  sortBy,
  compose,
  flatten,
  head,
  uniq,
  filter,
  map
} from "ramda";
import {
  showNotification,
  Button,
  SaveButton,
  SimpleForm,
  GET_ONE,
  GET_LIST,
  required
} from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import LinearProgress from "@material-ui/core/LinearProgress";
import dataProviderFactory from "../dataProvider";
import ListItemHistory from "./listItemHistory";
import moment from "moment";
import pluralize from "pluralize";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

class ItemSwitch extends Component {
  async fetchData() {
    const { type } = this.props;
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(
      GET_ONE,
      `items_available_to_switch/${type}`,
      { id: this.props.item.id }
    );
    return response.data;
  }

  handleItemChange = element => {
    this.setState({ newItem: element.target.value });
  };

  buildStructure = allItems => {
    const structure = [];
    const mainKeys = Object.keys(allItems);

    mainKeys.map(eventKey => {
      allItems[eventKey].map(event => {
        switch (eventKey) {
          case "rentals":
            structure.push({
              description: `${event.type === 2 ? "Rental" : "Tour"} ${
                event.id
              }`,
              title: `${event.driver.client_first_name} ${event.driver.client_last_name}`,
              event_id: event.id,
              date1: event.date_1,
              date2: event.date_2,
              location_id1: event.location_1 ? event.location_1.id : "",
              location1: event.location_1 ? event.location_1.location_name : "",
              cellLocation2Color: "",
              location2: event.location_2.location_name,
              location_id2: event.location_2.id,
              bgColor: event.location_1
                ? event.location_1.color
                : event.location_2.color,
              bgColor2: event.location_2
                ? event.location_2.color
                : event.location_1.color,
              key: `${eventKey}_${event.id}`,
              type: "rental"
            });
            break;
          case "holds":
            structure.push({
              description: `Hold ${event.id}`,
              title: `Hold`,
              date1: event.start_date,
              date2: event.end_date,
              location1: "",
              cellLocation2Color: "",
              location2: "",
              bgColor: "whiteSmoke",
              key: `${eventKey}_${event.id}`,
              type: "hold",
              event_id: event.id
            });
            break;
          case "transfers":
            structure.push({
              description: `Transfer ${event.id}`,
              title: `Transfer`,
              date1: event.start_date,
              date2: event.end_date,
              location1: event.location_1 ? event.location_1.location_name : "",
              location_id1: event.location_1 ? event.location_1.id : "",
              cellLocation2Color: event.location_2.color,
              location2: event.location_2.location_name,
              location_id2: event.location_2.id,
              bgColor2: event.location_2
                ? event.location_2.color
                : event.location_1.color,
              bgColor: event.location_1
                ? event.location_1.color
                : event.location_2.color,
              key: `${eventKey}_${event.id}`,
              type: "transfer",
              event_id: event.id
            });
            break;
          default:
            break;
        }
      });
    });
    return sortBy(compose(moment, prop("date1")), structure);
  };

  async fetchAvailableItens(itemType, date1, date2, location) {
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_LIST, "items_available_to_switch", {
      filter: { itemType, date1, date2, location },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    return response.data;
  }

  async componentDidUpdate() {
    if (this.state.showDialog) {
      await this.updateState();
    }
  }

  updateState = async () => {
    if (this.state.showDialog && isEmpty(this.state.data)) {
      const data = await this.fetchData();
      const events = this.buildStructure({
        rentals: data.rentals,
        holds: data.holds,
        transfers: data.transfers
      });

      let availableItems = [];

      await Promise.all(
        events.map(async event => {
          availableItems.push(
            await this.fetchAvailableItens(
              pluralize.singular(this.props.type),
              prop("date1", event),
              prop("date2", event),
              prop("location_id2", head(events))
            )
          );
        })
      );

      const resultItems = availableItems.map(item => prop("result", item));
      const removedItems = uniq(
        flatten(availableItems.map(item => prop("removed_items", item)))
      );

      availableItems = flatten(
        sortBy(prop("id"), uniqBy(prop("id"), resultItems))
      );
      const filtered = filter(
        obj => !removedItems.includes(obj.item_id),
        availableItems
      );

      this.setState({
        data,
        events,
        availableItems: filtered
      });
    }
  };

  state = {
    data: {},
    events: {},
    error: false,
    showDialog: false,
    newItem: 0,
    availableItems: {}
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({
      showDialog: false,
      availableItems: {},
      data: {},
      events: {},
      newItem: 0
    });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    submit("item-switch-update");
  };

  handleSubmit = async () => {
    const rentalsToChange =
      filter(obj => obj.type === "rental", this.state.events).map(item =>
        prop("event_id", item)
      ) || [];
    const bodyRequest = {
      id: this.props.item.id,
      data: {
        type: this.props.type,
        newId: this.state.newItem,
        rentals: rentalsToChange
      }
    };
    const dataProvider = await dataProviderFactory("rest");
    dataProvider(UPDATE, "items_available_to_switch", bodyRequest)
      .then(() => {
        this.setState({
          showDialog: false,
          availableItems: {},
          data: {},
          events: {},
          newItem: 0
        });
        const { history } = this.props;
        history.replace(
          `/${this.props.type}?filter=%7B"status"%3A"A"%7D&page=1&perPage=10`
        );
      })
      .catch(error => {
        showNotification(error.message, "error");
      });
  };

  render() {
    const { showDialog, availableItems } = this.state;
    const { isSubmitting } = this.props;
    const { model } = this.props.item;

    return (
      <Fragment>
        <Button label="Switch Activity" onClick={this.handleClick}>
          <IconCancel />
        </Button>
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Retire bike"
        >
          <DialogTitle>Switch Item Activity - {model}</DialogTitle>
          <DialogContent>
            <ListItemHistory itemData={this.state.events} />
            <SimpleForm
              form="item-switch-update"
              resource="items_available_to_switch"
              onSubmit={this.handleSubmit}
              toolbar={null}
            >
              {!isEmpty(availableItems) && (
                <Select
                  onChange={this.handleItemChange}
                  inputProps={{
                    name: "model",
                    id: "item_id"
                  }}
                  validate={required()}
                  value={this.state.newItem}
                >
                  {map(item => {
                    return (
                      <MenuItem value={item.item_id}>{item.model}</MenuItem>
                    );
                  }, availableItems)}
                </Select>
              )}
              {isEmpty(availableItems) && <LinearProgress />}
            </SimpleForm>
          </DialogContent>
          <DialogActions>
            <SaveButton
              saving={isSubmitting}
              onClick={this.handleSaveClick}
              disabled={this.state.newItem === 0}
            />
            <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("item-switch-update")(state)
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemSwitch);



// WEBPACK FOOTER //
// ./src/components/itemSwitch.js